export const mutations = {
  SET_FOOTER_MENUS(state, { payload }) {
    state.footerMenus = payload
    // console.log('FOOTER', payload)
  },
}
